export async function revokeAiChatHumanSession(): Promise<void> {
  try {
    await fetch('/api/ai-chat/human-session', {
      method: 'DELETE',
      credentials: 'same-origin',
      keepalive: true,
    });
  } catch {
    // Supabase sign-out still proceeds; the server also requires a matching login user.
  }
}
